/*
 * amphr announcement bar — seamless marquee
 *
 * The bar used to fade between messages, each on one clipped line. Measured at
 * 375px: the track is 280px wide and the three messages are 348 / 676 / 361px,
 * so all three were cut at both ends. Fitting the longest one on a single line
 * would have needed a 7px font. The messages now scroll instead.
 *
 * The CSS animation shifts the track by exactly one group width, so the loop is
 * seamless as long as the track holds at least (viewport + group) pixels. This
 * file measures the group, clones it until that holds, and derives the duration
 * from a constant speed in px/s — so a longer message scrolls for longer
 * instead of scrolling faster.
 */
(function () {
  'use strict';

  var DEFAULT_SPEED = 55; /* px per second */
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function clearClones(track) {
    var clones = track.querySelectorAll('.amphr-anns__group[data-clone]');
    Array.prototype.forEach.call(clones, function (node) {
      node.parentNode.removeChild(node);
    });
  }

  function setup(bar) {
    var track = bar.querySelector('.amphr-anns__track');
    if (!track) return;
    var group = track.querySelector('.amphr-anns__group:not([data-clone])');
    if (!group) return;

    clearClones(track);
    track.style.removeProperty('--amphr-marq-shift');
    track.style.removeProperty('--amphr-marq-dur');

    /* Reduced motion: the CSS falls back to a static, wrapping bar. */
    if (motionQuery.matches) return;

    var groupWidth = group.getBoundingClientRect().width;
    if (!groupWidth) return;

    var speed = parseFloat(bar.getAttribute('data-speed')) || DEFAULT_SPEED;
    var needed = bar.clientWidth + groupWidth;
    var total = groupWidth;

    /* Guard: a pathological group width must not spin this loop. */
    var guard = 20;
    while (total < needed && guard--) {
      var clone = group.cloneNode(true);
      clone.setAttribute('data-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      Array.prototype.forEach.call(clone.querySelectorAll('a'), function (a) {
        a.setAttribute('tabindex', '-1');
      });
      track.appendChild(clone);
      total += groupWidth;
    }

    track.style.setProperty('--amphr-marq-shift', groupWidth.toFixed(2) + 'px');
    track.style.setProperty('--amphr-marq-dur', (groupWidth / speed).toFixed(2) + 's');
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.amphr-anns'), setup);
  }

  var resizeTimer = null;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 150);
  }

  function start() {
    initAll();
    /* Web fonts land after first paint and change the measured width. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(initAll);
    }
    window.addEventListener('resize', onResize);
    if (motionQuery.addEventListener) {
      motionQuery.addEventListener('change', initAll);
    } else if (motionQuery.addListener) {
      motionQuery.addListener(initAll);
    }
    /* Theme editor re-renders the section without reloading the page. */
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:section:unload', initAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
